export default "__VITE_ASSET__BvCoc87v__"